import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon, MailIcon, GlobeIcon, FacebookIcon, TwitterIcon, InstagramIcon, LinkedinIcon } from 'lucide-react';
const Footer = () => {
  return <footer className="bg-[#1A1F47] text-white" data-id="element-249">
      <div className="container mx-auto px-4 py-12" data-id="element-250">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-251">
          <div data-id="element-252">
            <div className="flex items-center space-x-2 mb-4" data-id="element-253">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rpQsFTDpkU3aJLqnBMGk5S/Veriprop_wh.png" alt="VeriProp Logo" className="h-8 w-auto" data-id="element-254" />
              <span className="text-xl font-bold" data-id="element-255">VeriProp</span>
            </div>
            <p className="text-gray-300 mb-4" data-id="element-256">
              Secure real estate platform connecting Nigerians in the diaspora
              with trusted property solutions back home.
            </p>
            <div className="flex space-x-4" data-id="element-257">
              <a href="#" className="text-gray-300 hover:text-white" data-id="element-258">
                <FacebookIcon size={20} data-id="element-259" />
              </a>
              <a href="#" className="text-gray-300 hover:text-white" data-id="element-260">
                <TwitterIcon size={20} data-id="element-261" />
              </a>
              <a href="#" className="text-gray-300 hover:text-white" data-id="element-262">
                <InstagramIcon size={20} data-id="element-263" />
              </a>
              <a href="#" className="text-gray-300 hover:text-white" data-id="element-264">
                <LinkedinIcon size={20} data-id="element-265" />
              </a>
            </div>
          </div>
          <div data-id="element-266">
            <h3 className="text-lg font-semibold mb-4" data-id="element-267">Quick Links</h3>
            <ul className="space-y-2" data-id="element-268">
              <li data-id="element-269">
                <Link to="/" className="text-gray-300 hover:text-white" data-id="element-270">
                  Home
                </Link>
              </li>
              <li data-id="element-271">
                <Link to="/properties" className="text-gray-300 hover:text-white" data-id="element-272">
                  Properties
                </Link>
              </li>
              <li data-id="element-273">
                <Link to="/services" className="text-gray-300 hover:text-white" data-id="element-274">
                  Services
                </Link>
              </li>
              <li data-id="element-275">
                <Link to="/dashboard" className="text-gray-300 hover:text-white" data-id="element-276">
                  Dashboard
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-277">
            <h3 className="text-lg font-semibold mb-4" data-id="element-278">Services</h3>
            <ul className="space-y-2" data-id="element-279">
              <li data-id="element-280">
                <a href="#" className="text-gray-300 hover:text-white" data-id="element-281">
                  Property Verification
                </a>
              </li>
              <li data-id="element-282">
                <a href="#" className="text-gray-300 hover:text-white" data-id="element-283">
                  Legal Services
                </a>
              </li>
              <li data-id="element-284">
                <a href="#" className="text-gray-300 hover:text-white" data-id="element-285">
                  Interior Design
                </a>
              </li>
              <li data-id="element-286">
                <a href="#" className="text-gray-300 hover:text-white" data-id="element-287">
                  Property Management
                </a>
              </li>
              <li data-id="element-288">
                <a href="#" className="text-gray-300 hover:text-white" data-id="element-289">
                  Secure Document Delivery
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-290">
            <h3 className="text-lg font-semibold mb-4" data-id="element-291">Contact Us</h3>
            <div className="space-y-3" data-id="element-292">
              <div className="flex items-start space-x-3" data-id="element-293">
                <PhoneIcon size={18} className="mt-1 text-[#FF4E00]" data-id="element-294" />
                <span data-id="element-295">+2347069243079</span>
              </div>
              <div className="flex items-start space-x-3" data-id="element-296">
                <MailIcon size={18} className="mt-1 text-[#FF4E00]" data-id="element-297" />
                <span data-id="element-298">info@veriprop.org</span>
              </div>
              <div className="flex items-start space-x-3" data-id="element-299">
                <GlobeIcon size={18} className="mt-1 text-[#FF4E00]" data-id="element-300" />
                <span data-id="element-301">www.veriprop.org</span>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400" data-id="element-302">
          <p data-id="element-303">
            &copy; {new Date().getFullYear()} VeriProp. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;